export const useScrollToTop = (top = 0, behavior: ScrollBehavior = 'smooth') =>
  window.scrollTo({ top, behavior })
